import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { StripedWordmark, TricolorStrip } from '../components/BSCAuthLayout';
import { useAuth } from '../context/AuthContext';
import { LogOut, ArrowLeft, Construction } from 'lucide-react';

/**
 * Generic "In Development" placeholder for tiles that aren't built yet.
 * Same look-and-feel as other tile pages so the user has navigation continuity.
 *
 * Usage: <ComingSoon wordmark="EXECUTION" subtitle="Project Execution & Delivery" />
 */
export default function ComingSoon({ wordmark, subtitle }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => { await logout(); navigate('/login'); };

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#F7F5F0' }}>
      <div className="border-b" style={{ backgroundColor: '#0A0A0A', borderColor: '#1a1a1a' }}>
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="back-to-launcher">
            <img src="/bsc-logo.jpeg" alt="BSC" className="w-9 h-9 rounded-lg" />
            <div className="flex flex-col leading-tight">
              <StripedWordmark text={wordmark} size="sm" />
              <span className="text-white/40 text-[10px] tracking-[0.3em] uppercase">{subtitle}</span>
            </div>
          </Link>
          <div className="flex items-center gap-3">
            <span className="text-white/70 text-sm">{user?.name}</span>
            <Button variant="ghost" size="sm" onClick={handleLogout} className="text-white/70 hover:text-white" data-testid="logout-button">
              <LogOut size={14} className="mr-1" />Logout
            </Button>
          </div>
        </div>
        <TricolorStrip />
      </div>

      <div className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center" data-testid="coming-soon-card">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full mb-6" style={{ backgroundColor: '#0A0A0A' }}>
            <Construction size={36} color="#C77D38" />
          </div>
          <div className="mb-2 flex justify-center">
            <StripedWordmark text={wordmark} size="md" />
          </div>
          <p className="text-sm uppercase tracking-[0.2em] mb-6" style={{ color: '#5C5C5C' }}>{subtitle}</p>
          <div className="bg-white border rounded-lg p-6" style={{ borderColor: '#E8E5DF' }}>
            <h2 className="text-lg font-semibold mb-2" style={{ fontFamily: 'Manrope', color: '#1A1A1A' }}>In Development</h2>
            <p className="text-sm" style={{ color: '#5C5C5C' }}>This module is being designed and built. We'll roll it out in an upcoming release. Want it sooner? Drop the requirements with the team.</p>
          </div>
          <Button onClick={() => navigate('/')} variant="outline" className="mt-6" data-testid="back-button">
            <ArrowLeft size={14} className="mr-1" />Back to Launcher
          </Button>
        </div>
      </div>
    </div>
  );
}
